// eslint-disable-next-line

import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateRoutes = () => {
	const { user } = useContext(AuthContext);

	return user ? <Outlet /> : <Navigate to="/login" />;
};

// Issue #89: /dashboard はログイン判定のみのPrivateRoutes配下にあるため、一般ユーザーも
// URL直打ちで到達できてしまう。isAdmin/is_superuserを持たないユーザーは"/"へ戻す。
// 判定基準はHeader/Dashboard/HomePageの既存出し分けと同一(user.isAdmin || user.is_superuser)。
export const AdminRoute = () => {
	const { user } = useContext(AuthContext);

	return user && (user.isAdmin || user.is_superuser) ? (
		<Outlet />
	) : (
		<Navigate to="/" replace />
	);
};

export default PrivateRoutes;
